import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/search.svg'
import _imports_1 from '@/assets/img/chat/chat_on.svg'
import _imports_2 from '@/assets/img/chat/chat_off.svg'
import _imports_3 from '@/assets/img/chat/chatRequest_on.svg'
import _imports_4 from '@/assets/img/chat/chatRequest_off.png'
import _imports_5 from '@/assets/img/plus.svg'


const _hoisted_1 = { class: "hasHeader hasFooter" }
const _hoisted_2 = { class: "header withShadow" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "tabContainer" }
const _hoisted_5 = {
  key: 0,
  src: _imports_1
}
const _hoisted_6 = {
  key: 1,
  src: _imports_2
}
const _hoisted_7 = {
  key: 2,
  class: "activeBar active"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "pallinoNotifiche" }
const _hoisted_10 = {
  key: 1,
  src: _imports_3
}
const _hoisted_11 = {
  key: 2,
  src: _imports_4
}
const _hoisted_12 = {
  key: 3,
  class: "activeBar active"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_17 = { class: "squareActionButtonsContainer" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_conversation_vm = _resolveComponent("conversation-vm")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "searchContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSearchModal()))
      }, [
        _hoisted_3,
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue ms-2",
          localizedKey: "app_chatSearchText",
          text: "Chat, utenti..."
        })
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", {
        class: "tab",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'chats'))
      }, [
        (_ctx.activeTab == 'chats')
          ? (_openBlock(), _createBlock("img", _hoisted_5))
          : (_openBlock(), _createBlock("img", _hoisted_6)),
        _createVNode(_component_localized_text, {
          localizedKey: "app_chats",
          text: "Chats",
          class: _ctx.activeTab == 'chats' ? 'fs_10 d-block mt-1 spaceCadet' : 'fs_10 d-block mt-1 grey'
        }, null, 8, ["class"]),
        (_ctx.activeTab == 'chats')
          ? (_openBlock(), _createBlock("div", _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        class: "tab",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'requests'))
      }, [
        (_ctx.requests.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.requests.length), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab == 'requests')
          ? (_openBlock(), _createBlock("img", _hoisted_10))
          : (_openBlock(), _createBlock("img", _hoisted_11)),
        _createVNode(_component_localized_text, {
          localizedKey: "app_requests",
          text: "Richieste",
          class: _ctx.activeTab == 'requests' ? 'fs_10 d-block mt-1 spaceCadet' : 'fs_10 d-block mt-1 grey'
        }, null, 8, ["class"]),
        (_ctx.activeTab == 'requests')
          ? (_openBlock(), _createBlock("div", _hoisted_12))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.activeTab == 'chats')
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          (_ctx.loadingConversations)
            ? (_openBlock(), _createBlock(_component_mini_spinner, {
                key: 0,
                class: "mt-5"
              }))
            : (_openBlock(), _createBlock("div", _hoisted_14, [
                (_ctx.chats.length == 0)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      localizedKey: "app_nessunaChatPresente",
                      text: "Nessuna chat presente",
                      class: 'fs_14 grey d-block text-center mt-5'
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chats, (item) => {
                  return (_openBlock(), _createBlock(_component_conversation_vm, {
                    item: item,
                    key: item.identifier,
                    onClick: ($event: any) => (_ctx.openChat(item))
                  }, null, 8, ["item", "onClick"]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeTab == 'requests')
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          (_ctx.loadingRequests)
            ? (_openBlock(), _createBlock(_component_mini_spinner, {
                key: 0,
                class: "mt-5"
              }))
            : (_openBlock(), _createBlock("div", _hoisted_16, [
                (_ctx.requests.length == 0)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      localizedKey: "app_nessunaRichiestaPresente",
                      text: "Nessuna richiesta presente",
                      class: 'fs_14 grey d-block text-center mt-5'
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.requests, (item) => {
                  return (_openBlock(), _createBlock(_component_conversation_vm, {
                    item: item,
                    key: item.identifier,
                    onClick: ($event: any) => (_ctx.openRequest(item))
                  }, null, 8, ["item", "onClick"]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", {
        class: "squareButton",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newChat()))
      }, [
        _hoisted_18
      ])
    ])
  ]))
}